import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { api } from "../../app/http/axiosClient";
import Placeholder from "../../assets/images/placeholderPoster.png";
import Header from "../../app/universalComponents/Header";
import TicketSelector from "./TicketSelector";
import Footer from "../../app/universalComponents/Footer"
import NotFoundPage from "../not-found/NotFoundPage";
import Loading from "../../app/universalComponents/Loading";

export default function EventDetailsPage() {
    const { eventSlug } = useParams();
    const [searchParams] = useSearchParams();

    const [event, setEvent] = useState(null);
    const [error, setError] = useState(false);

    const paymentCancelled = searchParams.get("cancelled") === "true";

    useEffect(() => {
        async function getEvent() {
            try {
                setError(false);

                const response = await api.get(`/public/events/${eventSlug}`);
                setEvent(response.data);
            } catch (err) {
                setError(true);
            }
        }

        if (eventSlug) {
            getEvent();
        } else {
            setError(true);
        }
    }, [eventSlug]);

    useEffect(() => {
        if (event) {
            document.title = `${event.title} | Tickets.NP`;
        }
    }, [event]);

    if (error) {
        return <NotFoundPage />;
    }

    if (!event) {
        return <Loading fullPage />;
    }

    return (
        <div className="lg:grid lg:grid-cols-3">

            <div className="lg:col-span-2">
                {paymentCancelled ? (
                    <div className="rounded-sm border border-b-yellow-300 bg-yellow-50 text-center py-3 text-sm text-yellow-800">
                        Payment cancelled. No money was taken. You can try again.
                    </div>
                ) : null}
                <Header />

                <main className="mx-6 py-4 space-y-4 lg:mx-20 lg:mb-6">


                    <section className="lg:flex gap-8">
                        <img
                            src={event.poster_image_key || Placeholder}
                            alt="event poster"
                            className="rounded-sm w-[250px] mx-auto lg:mx-0"
                        />

                        <div className="mt-6 lg:mt-0 flex flex-col gap-4">
                            <div className="mx-auto lg:mx-0">
                                <h1 className="text-4xl lg:text-5xl font-bold tracking-tight">
                                    {event.title}
                                </h1>

                                <p className="text-xs text-center lg:text-left font-semibold uppercase tracking-widest text-gray-500">
                                    By{" "}
                                    <span className="text-base font-medium normal-case tracking-normal text-gray-900">
                                        {event.organiser_name}
                                    </span>
                                </p>
                            </div>

                            <div className="space-y-4 rounded-sm border border-gray-300 bg-white/70 p-4 shadow-sm">
                                <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                                    Where{" "}
                                    <span className="block text-lg font-medium normal-case tracking-normal text-gray-900">
                                        {event.venue}
                                    </span>
                                </p>

                                <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                                    When{" "}
                                    <span className="block text-lg font-medium normal-case tracking-normal text-gray-900">
                                        <span className="block">{event.date}</span>
                                        <span className="block">
                                            {event.start_at} {event.end_at ? ` - ${event.end_at}` : ""}
                                        </span>
                                    </span>
                                </p>

                                <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                                    Who{" "}
                                    <span className="block text-lg font-medium normal-case tracking-normal text-gray-900">
                                        {event.attendees_age_range}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                            Info
                        </h2>

                        <p>{event.description}</p>
                    </section>
                    {event.slug === "bbq-booze-bingo" &&
                        <section>
                            <h2 className="text-xs font-semibold uppercase tracking-widest text-gray-500">
                                Organiser Terms and Conditions
                            </h2>
                            <ul className="list-disc pl-4 text-xs">
                                <li>
                                    Tickets are non-refundable.
                                </li>

                                <li>
                                    The organisers are not responsible for any lost, stolen, or damaged personal belongings.
                                </li>

                                <li>
                                    By attending the event, participants acknowledge that photos and videos may be taken and used by the organisers for promotional and social media purposes.
                                    Participants are expected to drink responsibly.
                                </li>
                            </ul>
                        </section>
                    }
                </main>
            </div>

            <TicketSelector ticketTypes={event.ticket_types} />

            <Footer />
        </div>
    );
}